import { render, staticRenderFns } from "./rebateRecWarn.vue?vue&type=template&id=0b460938"
import script from "./rebateRecWarn.vue?vue&type=script&lang=js"
export * from "./rebateRecWarn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports